import { ProList } from "@ant-design/pro-components";
import { Button, Card, Col, Input, Row } from "antd";
import { useTranscript } from "../controller/TranscriptController";
import { useEffect, useRef, useState } from "react";
import dayjs from 'dayjs'
import { useParams } from "react-router-dom";
import Recorder from "../view/Recorder";

const Live = ({
    admin = false,
    roomId = null,
    size = 20,
}) => {
    const { RoomId } = useParams()
    const room_id = RoomId ?? roomId
    const actionRef = useRef();
    const axiosRef = useRef(true);
    const postRef = useRef(false);
    const transcriptId = useRef(null);
    const patchRef = useRef(setTimeout(() => { }, 0))
    const [pageSize, setPageSize] = useState(size)
    const [sentence, setSentence] = useState('')
    const handleOnPatch = () => {
        patchTranscriptData([{
            transcript_id: transcriptId.current,
            content: sentence
        }]);
    }
    const {
        getTranscriptData,
        postTranscriptData,
        patchTranscriptData
    } = useTranscript({
        onFinish: async ({ axiosMode, status, transcript_id }) => {
            if (axiosMode === "get") {
                if (axiosRef.current) {
                    setTimeout(() => {
                        actionRef.current.reload()
                    }, 5000)
                }
            } else if (axiosMode === "post") {
                if (status === "success") {
                    transcriptId.current = transcript_id
                }
            } else if (axiosMode === "patch") {
                if (postRef.current) {
                    transcriptId.current = null
                    postRef.current = false
                }
            }
        },
        onBefore: () => { },
    })
    useEffect(() => {
        return () => {
            axiosRef.current = false
        }
    }, [])
    return (<>
        {admin && <>
            <Card>
                <Row gutter={[24, 0]}>
                    <Col>
                        <Recorder
                            startTitle="開始錄音"
                            endTitle="停止錄音"
                            onReceive={async (sentence) => {
                                setSentence(sentence)
                                postRef.current = true
                                patchTranscriptData([{
                                    transcript_id: transcriptId.current,
                                    content: sentence
                                }]);
                            }}
                            onChange={async (sentence) => {
                                setSentence(sentence)
                                if (!transcriptId.current) {
                                    await postTranscriptData([{
                                        content: sentence,
                                        room_transcript_data: [
                                            {
                                                room_id: room_id
                                            }
                                        ]
                                    }]);
                                } else {
                                    clearImmediate(patchRef.current)
                                    patchRef.current = setTimeout(() => {
                                        handleOnPatch()
                                    }, 1000)
                                }
                            }}
                        />
                    </Col>
                    <Col>
                        <Input
                            value={sentence}
                            disabled
                        />
                    </Col>
                </Row>
            </Card>
        </>}
        <ProList
            actionRef={actionRef}
            request={async (params = {}, sort, filter) => {
                let newParams = {
                };
                let order = [
                    JSON.stringify({
                        column: 'transcript_id',
                        type: 'DESC'
                    })
                ]
                newParams = {
                    ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                    ...newParams,
                    order,
                    size: params?.pageSize ?? size,
                    cur_page: params.current,
                    room_id: room_id
                };
                newParams = setParamsFilter({
                    ...newParams,
                });
                setPageSize(params?.pageSize ?? size)

                return getTranscriptData(newParams)
            }}
            rowKey="transcript_id"
            // headerTitle="基础列表"
            showActions="hover"
            pagination={{
                pageSize: pageSize,
                showSizeChanger: true,
            }}
            metas={{
                title: {
                    dataIndex: 'create_time',
                    title: '時間',
                    render: (text, row) => {
                        return dayjs(text).format('YYYY-MM-DD HH:mm:ss');
                    },
                },
                // avatar: {
                //     dataIndex: 'avatar',
                //     search: false,
                // },
                // subTitle: {
                //     dataIndex: 'labels',
                //     render: (_, row) => {
                //         return (
                //             <Typography.Text type={'secondary'}>00:08</Typography.Text>
                //         );
                //     },
                //     search: false,
                // },
                content: {
                    render: (_, row) => {
                        return (
                            <Input
                                disabled
                                value={row.content}
                            />
                        );
                    },
                },
                // actions: {
                //     render: (text, row, index) =>
                //         <div style={{ width: 250 }}>
                //             {index % 2 == 0 ? [
                //                 <Row justify={'start'}>
                //                     <Col>
                //                         <Button size={'large'} type={'text'} style={{backgroundColor:'rgb(175,137,215)',color:'white'}}>＋建立追蹤</Button>
                //                     </Col>
                //                 </Row>,
                //             ] : [
                //                 <Row justify={'start'} gutter={[8,8]}>
                //                     <Col>
                //                         <Button size={'large'} type={'text'} style={{backgroundColor:'rgb(161,212,138)',color:'white'}}>已建立追蹤</Button>
                //                     </Col>
                //                     <Col>
                //                         <Button size={'large'} type={'text'} style={{backgroundColor:'rgb(74,74,74)',color:'white'}}>取消</Button>
                //                     </Col>
                //                 </Row>,
                //             ]}
                //         </div>,
                //     search: false,
                // },
            }}
        />
    </>)
}
export default Live;
const setParamsFilter = (obj) => {
    //拿掉值為空或是null 的東西
    return Object.entries(obj).reduce((all, [key, value]) => value === "" ? { ...all } : { ...all, [key]: value }, {})
}